const eventEntities = (state) => state.subscriptions.events;

export const getEventsByType = (state, entityId, eventType) => {
    return eventEntities(state).filter(ev => ev.entity === entityId && ev.type === eventType);
}